export enum DashboardListMode {
  Actual = 'actual',
  Diverging = 'diverging',
}

export interface PageOneMaxes {
  positive: number | null;
  negative: number | null;
}
